
import { useCallback } from 'react';
import { SearchResult } from '@/types/search';

const pages = [
  { name: 'Dashboard', path: '/dashboard', description: 'Visão geral das finanças' },
  { name: 'Transações', path: '/transacoes', description: 'Gerenciar receitas e despesas' },
  { name: 'Cartões', path: '/cartoes', description: 'Gerenciar cartões de crédito' },
  { name: 'Contas', path: '/contas', description: 'Gerenciar contas bancárias' },
  { name: 'Categorias', path: '/categorias', description: 'Organizar categorias' },
  { name: 'Orçamentos', path: '/orcamentos', description: 'Controlar gastos mensais' },
  { name: 'Metas', path: '/metas', description: 'Acompanhar objetivos financeiros' },
  { name: 'Lançamentos', path: '/lancamentos', description: 'Gerenciar lançamentos futuros e dívidas' },
  { name: 'Agenda', path: '/agenda', description: 'Agenda financeira mensal' },
  { name: 'Relatórios', path: '/relatorios', description: 'Análises e gráficos detalhados' },
  { name: 'Configurações', path: '/configuracoes', description: 'Ajustar preferências do sistema' },
  { name: 'Ajuda e Suporte', path: '/ajuda-e-suporte', description: 'Central de ajuda, tutoriais e suporte' },
  { name: 'Fórum', path: '/forum', description: 'Fórum de suporte com respostas detalhadas' }
];

export const usePagesSearch = () => {
  const searchPages = useCallback((query: string): SearchResult[] => {
    if (!query || query.length < 2) return [];

    const lowerQuery = query.toLowerCase();
    
    return pages
      .filter(page => 
        page.name.toLowerCase().includes(lowerQuery) ||
        page.description.toLowerCase().includes(lowerQuery)
      )
      .map(page => ({
        id: page.path,
        title: page.name,
        subtitle: page.description,
        type: 'page' as const,
        tag: 'Página',
        data: { path: page.path }
      }));
  }, []);

  return { searchPages };
};
